/**
 * Shared defaults for @tanstack/react-virtual lists in CRM (SimpleTable mobile + desktop).
 * Aligns with DataTable-modular overscan style; tune estimates if row/card chrome changes.
 */
export const CRM_VIRTUAL_OVERSCAN = 10;

/** Typical mobile entity card (content + padding); gap between cards added separately */
export const ESTIMATE_MOBILE_ENTITY_CARD_PX = 168;

export const MOBILE_CARD_LIST_GAP_PX = 12;

/** Default table data row height estimate (SimpleTable rows) */
export const ESTIMATE_TABLE_DATA_ROW_PX = 52;

/** Group header row in grouped list view */
export const ESTIMATE_GROUP_HEADER_ROW_PX = 44;
